import { OnboardingEnvironment } from './interface';

export const environment: OnboardingEnvironment = {
  production: true,
  hmr: false,
  protocol: 'https',
  domain: 'api.s.recruitee.com',
  webappUrl: 'https://app.s.recruitee.com/',
  landingPageUrl: 'https://s.recruitee.com/',
  phraseAppProjectId: 'cea66a528621d963077fdbb152355ac8',
  apiUserUrl: 'https://auth.s.recruitee.com/sign-up-admin',
  apiUserDataUrl: 'https://auth.s.recruitee.com/invitation/',
  apiTimeFormat24Url: 'https://api.s.recruitee.com/time_format',
  apiCompanyUrl: 'https://auth.s.recruitee.com/sign-up',
  apiCompanyDataUrl: 'https://auth.s.recruitee.com/sign-up-confirmation/',
  appAuthUrl: 'https://auth.s.recruitee.com/',
  signInUrl: 'https://auth.s.recruitee.com/sign-in/',
  apiCountryCodeUrl:
    'https://api.ipdata.co/country_code?api-key=94c7fbfbf4ef81024167b475c71b479f80b6a6d02c84ff94c738e00a',
  supportEmail: 'support@recruitee.com',
  growsumoPublicKey: 'pk_86389cd9dcf0488c81b2113893302a82',
  analytics: true,
  analyticsKey: 'DlaokckWxNBiyBoQUTZJGRRF4MeRanyf',
  sentry_dsn: 'https://80c6c6f0815e4694ac9e40ecffcfea54@o18167.ingest.sentry.io/1807450',
};
